var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-screen bg-primary flex flex-col"},[_c('div',{class:[
      'flex justify-center w-full',
      _vm.onboardingStarted
        ? 'relative'
        : 'xs:absolute xs:top-10 md:absolute md:top-20 animate-pulse-in' ]},[_c('Logo',{attrs:{"isWhite":true,"svgClass":"w-60 md:w-80"}})],1),_c('div',{staticClass:"flex-grow h-full flex justify-center"},[_c('div',{staticClass:"flex w-full h-full justify-center pt-0 max-w-screen-lg"},[(!_vm.onboardingStarted)?_c('Welcome',{attrs:{"onEnterGame":_vm.startOnboarding}}):_c('Onboarding')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }